import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Defaults to localStorage for web

// Import reducers
import universityReducer from './Slice/universitySlice';
import studentReducer from './Slice/studentSlice';
import infoSliceReducer from './Slice/infoSlice';
import authReducer from './Slice/authSlice';

// Combine all reducers into a rootReducer
const rootReducer = combineReducers({
  info: infoSliceReducer,
  auth: authReducer,
  university: universityReducer,
  student: studentReducer,
});

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['info'], // Only persist the 'info' slice
};

// Create a persisted reducer using the configuration
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store with the persisted reducer
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

// Create the persistor
export const persistor = persistStore(store);
